import React from "react";

const Drives = () => {
  return (
    <div>
      <h2>Drives</h2>

      <li className="listHeading">Trauma Drive</li>
      <li className="list">\\UPHSPF15\SharedData1\Hup\Trauma\Shared</li>
      <li className="listHeading">Transplant Drives</li>
      <li className="list">\\UPHSFP10\TransplantDept-HUP$</li>

      <li className="list">\UPHSFP11\Psydbase$</li>

      <li className="list">\\UPHSFP10\TRANSNET_HUP$</li>

      <li className="listHeading">Surgery Drives </li>

      <li className="list">\\uphappndc186\surgery-alt</li>

      <li className="list">\SURGSERVER1\</li>

      <li className="list">\\uphappndc186\surgery-hup</li>

      <li className="listHeading">Urology Drives</li>

      <li className="list">\UphsFP13\SharedData3\HUP\Urology</li>

      <li className="listHeading">Finance</li>

      <li className="list">\\surgserver1\jdisk\Surgadmin\Salaries</li>

      <li className="list">\\surgserver1\jdisk\HDSR Shared Drive</li>

      <li className="listHeading">Education</li>

      <li className="list">\\surgserver1\jdisk\DSE_office</li>

      <li className="listHeading">Plastics Research</li>

      <li className="list">Group in AD: Isilon-PlasticSurgeryData</li>

      <li className="listHeading">Neurology Imaging</li>

      <li className="list">\\isilon-surgeryresearch\surgery\Neurosurgery</li>

      <li className="listHeading">Pennmobile apps website</li>

      <li className="list">http://mhealth.pennmedicine.org/</li>
      
      <li className="listHeading">Tavr/Presby drive</li>
    
      <li className="list">AD group: Group_Valve_Center \\uphsfp17\workgroup\valve_center Has to be manually mapped</li>
    
      <li className="listHeading">Syngo website</li>
      

      <li className="list">http://uphsyndypor01/sdportal/ Have to use IE </li>
      <li className="listHeading">PMWS Surgery Group name is the same</li>
      <li className="list">Maps the J drive \\Uphsfp12\PMWSSurgery$</li>
      
    </div>
  );
};
export default Drives;
